<template>
  <v-dialog v-model="visible" persistent max-width="445">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.deleteTimePolicy`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          :disabled="isFetching"
          @click.native="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        v-if="isValidObject(timePolicy)"
        class="px-4 pt-0 pb-5"
        v-html="$t(`${namespace}.areYouSureDesc`).replace('[POLICY_NAME]', `<strong>${timePolicy.name}</strong>`)"
      />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="primary"
          flat
          round
          :disabled="isFetching"
          @click.prevent="close"
        >
          {{ $t('Common.cancel') }}
        </a>
        <v-btn
          round
          depressed
          color="primary"
          :loading="isFetching"
          :disabled="isFetching"
          @click.native="deleteTimePolicy"
        >
          {{ $t(`${namespace}.deleteTimePolicy`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isValidObject, catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'DeleteSingleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    timePolicy: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePoliciesPage',
      isFetching: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isValidObject(val)
    },

    close () {
      this.$emit('close')
    },

    setLoadingValue (boolean) {
      this.isFetching = boolean
    },

    async deleteTimePolicy () {
      this.setLoadingValue(true)

      try {
        await this.$apiService.deleteTimePolicy(this.timePolicy.id)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.dialogDeleteSuccess`)
        })
        this.$emit('update')
        this.close()
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.dialogDeleteError`)
        })
        catchError(error)
      }

      this.setLoadingValue(false)
    }
  }
}
</script>
